import { render, staticRenderFns } from "./PrestationsSubcategoriesTable.vue?vue&type=template&id=e1258266&scoped=true"
import script from "./PrestationsSubcategoriesTable.vue?vue&type=script&lang=js"
export * from "./PrestationsSubcategoriesTable.vue?vue&type=script&lang=js"
import style0 from "./PrestationsSubcategoriesTable.vue?vue&type=style&index=0&id=e1258266&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1258266",
  null
  
)

export default component.exports